import styled from '@emotion/styled'
import { metrics, ThemeMargins } from '../../__styling/settings/metrics'
import { breakpoint, breakpointMax } from '../../__styling/style-functions'
import {
    horizontalDividers,
    verticalDividers,
} from '../../__styling/style-mixins'
import { SierraLayouts } from './Sierra'

export interface GridProps {
    verticalSpacing: keyof ThemeMargins | undefined
    cardLayout: SierraLayouts
}

export const StyledSierra = styled('div')<GridProps>(
    ({ cardLayout, theme, verticalSpacing }) => ({
        margin: '0 auto',
        width: '100%',
        position: 'relative',
        display: 'grid',
        gridGap: theme.margins.gridGap,
        gridTemplateColumns: '100%',
        marginBottom: verticalSpacing && theme.margins[verticalSpacing],
        paddingBottom:
            theme.kind === 'thewest' ? metrics.thewest.margins.sm : undefined,

        [breakpoint('md')]: {
            // For 2 items it's a 4 column grid, for 3 items it's a 5 column grid.
            gridTemplateColumns: `repeat(${cardLayout.length + 2}, 1fr)`,
        },
    }),
)
export const StyledHeader = styled('div')((props) => ({
    display: 'block',
    marginBottom: props.theme.margins.md,
}))

interface SierraCardContainerProps {
    cardLayout: SierraLayouts
    hasBorder?: boolean
}

export const SierraCardContainer = styled('div')<SierraCardContainerProps>(
    ({ hasBorder, theme }) => ({
        width: '100%',

        marginBottom: 0,

        [breakpoint('md')]: {
            '&.heroCardContainer': {
                width: 'auto',
                marginRight: 0,
                gridColumnStart: 'span 3',
            },

            '&.portraitCardContainer': {
                gridColumnStart: 'span 1',
                width: 'auto',
                marginRight: 0,
                borderBottom: hasBorder
                    ? `1px solid ${theme.colors.borders.primary}`
                    : undefined,
                '+ .portraitCardContainer': {
                    marginLeft: 0,
                },
            },
        },
    }),
    ({ theme }) =>
        theme.kind === 'thewest' && {
            marginBottom: 0,
            position: 'relative',

            // Horizontal dividers only on small viewports for bottom of columns
            [breakpointMax('md')]: {
                '&::before': {
                    ...horizontalDividers,
                    backgroundColor: theme.colors.borders.primary,
                },
            },

            [breakpoint('md')]: {
                // Vertical dividers
                '&:not(:first-child)::after': {
                    ...verticalDividers,
                    backgroundColor: theme.colors.borders.primary,
                },
            },
        },
)
